import { dataRoad } from 'dls-icons-data'
import { createIcon } from '../common'

const IconRoad = /*#__PURE__*/createIcon(dataRoad)
export default IconRoad
